import goals from "../../../../src/components/content/goals/m7";
import * as React from 'react';
export default {
  goals,
  React
};